exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::-webkit-input-placeholder {\r\n    color: rgb(0, 174, 255);\r\n  }\n:-ms-input-placeholder {\r\n    color: rgb(0, 174, 255);\r\n  }\n::placeholder {\r\n    color: rgb(0, 174, 255);\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Git_new/IVMS_PRO/web/src/app/cam-login/cam-login.component.css
// module id = ../../../../../src/app/cam-login/cam-login.component.css
// module chunks = main